import { c as _c } from "react/compiler-runtime";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";
const BAR = "bg-[--textSecondaryOnColorSecondary]/20 rounded animate-pulse";
export default function FooterSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-6 lg:mx-0 flex justify-center mb-7 lg:mb-20 p-4"><div className={`h-7 w-3/4 max-w-2xl ${BAR}`} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={`mb-7 md:mb-0 ml-6 lg:ml-0 h-[118px] w-[240px] ${BAR}`} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col md:flex-row md:items-start md:justify-between max-w-7xl lg:gap-[168.37px]">{t1}<div className="w-full flex flex-col sm:flex-row sm:flex-wrap md:flex-nowrap md:justify-end gap-7 lg:gap-6 px-6 lg:px-0">{[3, 3].map(_temp2)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <footer aria-hidden="true" className="w-full bg-[var(--colorPrimaryOnPrimaryContainer,#06164B)] pt-[var(--spacing52)] pb-10"><MaxWidth>{t0}{t2}<div className="flex justify-center mt-10 lg:mt-16 mx-6 lg:mx-0"><div className={`h-3 w-64 ${BAR}`} /></div></MaxWidth></footer>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(count, i) {
  return <div key={i} className="flex flex-col gap-3 sm:min-w-[160px] md:min-w-0 lg:w-[212px]">{Array.from({
      length: count
    }).map(_temp)}</div>;
}
function _temp(_, j) {
  return <div key={j} className={`h-4 w-3/5 ${BAR}`} />;
}